import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { organizationTags } from '../mockData/organization-tags-data';

const OrganizationTagsApi = [
  rest.get(`${API_ROOT}tags`, (req, res, ctx) => res(ctx.json(organizationTags))),
  rest.patch(`${API_ROOT}tags/${organizationTags[0].id}`, (req, res, ctx) => res(ctx.json(organizationTags[0]))),
  rest.post(`${API_ROOT}tags`, (req, res, ctx) => res(ctx.json(organizationTags[0]))),
  rest.delete(`${API_ROOT}tags/${organizationTags[0].id}`, (req, res, ctx) => res(ctx.json(organizationTags[0]))),
];

export default OrganizationTagsApi;
